import * as React from 'react'

interface IDevFeatureMiddlewareProps {
  location: {
    search: string
  }
  children?: React.ReactNode
}

export function DevFeatureMiddleware(props: IDevFeatureMiddlewareProps) {
  React.useEffect(() => {
    const queries = props.location.search
      .slice(1)
      .split('&')
      .reduce((obj: { [key: string]: string }, query: string) => {
        const [key, value] = query.split('=')
        return {
          ...obj,
          [key]: value,
        }
      }, {})

    if (queries.feature) {
      try {
        window.localStorage.setItem(`dev-feature/${queries.feature}`, 'true')
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Could not enable feature ${queries.feature}`)
      }
    }

    if (queries.featureOff) {
      try {
        window.localStorage.removeItem(`dev-feature/${queries.featureOff}`)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Could not disable feature ${queries.featureOff}`)
      }
    }
  }, [props.location.search])

  return <>{props.children}</>
}

export function devFeatureEnabled(name: string) {
  try {
    return window.localStorage.getItem(`dev-feature/${name}`) === 'true'
  } catch (error) {
    return false
  }
}
